import { Form, Formik } from 'formik';
import React, { useState, useEffect } from 'react';
import { DropdownComponent, Input, TextArea, ToggleButton } from '../../../components/Inputs/Input';
import Typography from '../../../components/Typography/Typography';
import classes from './SupportNotes.module.css';
import { SupportNotesService } from '../../../services/SupportNotesService';
import { toast } from 'react-toastify';
import Dropdown from '../../../components/Inputs/Dropdown';

function SupportNoteForm({ setOpen, data, startLoader, stopLoader, setEditData, fetchNotes, customersData }) {
    const [initialValues, setinitialValues] = useState({
        title: '',
        description: '',
        released: new Date().toISOString().split('T')[0],
        enable: true,
        customerId: '',
    });

    const [customers, setCustomers] = useState([data?._id ? { label: data?.customerName, value: data?.customerId } : { label: 'None', value: '' }]);

    useEffect(() => {
        if (data?._id) {
            setinitialValues({
                ...data,
                released: data?.released.split('T')[0],
            });
        }
    }, [data]);

    const handleSubmit = (val) => {
        let payload = {
            supportNote: {
                ...val,
                released: new Date(val?.released),
            },
        };
        if (data?._id) {
            SupportNotesService.Update(data?._id, payload, startLoader, handleSuccess, handleError, stopLoader);
        } else {
            SupportNotesService.Create({ customerId: val.customerId }, payload, startLoader, handleSuccess, handleError, stopLoader);
        }
    };
    const handleSuccess = (data) => {
        setOpen(false);
        setEditData({});
        fetchNotes();
        toast.success('Note added');
    };

    useEffect(() => {
        let temp = [];
        customersData.forEach((element) => {
            temp.push({
                value: element._id,
                label: element.name,
            });
        });
        setCustomers(temp);
    }, [JSON.stringify(customersData)]);

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };
    return (
        <div className={classes.SupportNoteForm}>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={(val) => {
                    handleSubmit(val);
                }}
            >
                {({ errors, touched, values, isValidating, ...props }) => (
                    <Form>
                        <div>
                            <Typography content="Support Note" />
                            <div>
                                <div>
                                    <div className={classes.FieldControl}>
                                        <label for="title">
                                            Title <span className="required">*</span>
                                        </label>
                                        <Input
                                            name="title"
                                            id="title"
                                            setFieldValue={props.setFieldValue}
                                            setFieldTouched={props.setFieldTouched}
                                            getFieldMeta={props.getFieldMeta}
                                        />
                                    </div>
                                </div>
                                <div className={classes.FieldControl}>
                                    <label for="customerId">
                                        Customer ID <span className="required">*</span>
                                    </label>
                                    <Dropdown
                                        name="customerId"
                                        label="Customer ID"
                                        options={customers}
                                        defaultValue={data?._id ? { label: data?.customerName, value: data?.customerId } : customers[0]}
                                    />
                                </div>
                                <div>
                                    <div className={classes.FieldControl}>
                                        <label for="enable">Enabled</label>
                                        <ToggleButton name="enable" label="Enable" values={values} />
                                    </div>
                                </div>
                                <div className={classes.FieldControl}>
                                    <label for="released">
                                        Created At <span className="required">*</span>
                                    </label>
                                    <Input
                                        type="date"
                                        name="released"
                                        id="released"
                                        setFieldValue={props.setFieldValue}
                                        setFieldTouched={props.setFieldTouched}
                                        getFieldMeta={props.getFieldMeta}
                                    />
                                </div>
                                <div>
                                    <div className={classes.FieldControl}>
                                        <label for="description">
                                            Description <span className="required">*</span>
                                        </label>
                                        <TextArea
                                            name="description"
                                            label="description"
                                            setFieldValue={props.setFieldValue}
                                            setFieldTouched={props.setFieldTouched}
                                            getFieldMeta={props.getFieldMeta}
                                        />
                                    </div>
                                </div>
                                <div className={classes.ButtonContainer}>
                                    <div>
                                        <button
                                            className="btn-secondary"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setOpen(false);
                                                setEditData({});
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div>
                                        <button className="btn-primary">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default SupportNoteForm;
